import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import './ServiceRequestFormQuestions.scss';
import { fetchFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectItemFaqsByTypeAndCategory } from '../../store/selectors/items';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import { setServiceRequestFormNextStep, setServiceRequestFormStep, setServiceRequestFormPreviousStep, exitServiceRequestForm, setServiceRequestFormData } from '../../store/actions/serviceRequestForm';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Icon from '../Icon';
import Row from '../Row';
import { selectFaqByIssueType } from '../../store/selectors/faqsNotesDocuments'

class ServiceRequestFormFaqs extends Component {
  render() {
    const { serviceRequestFormData, faqs, onSetServiceRequestFormStep, onSetServiceRequestFormData, onSetServiceRequestFormNextStep, onSetServiceRequestFormPreviousStep, onExitServiceRequestForm, onExit,faqsByIssue } = this.props;
    let itemFaq = serviceRequestFormData.category;
    return (
      <Form
        // headline={serviceRequestFormData.category}
        headline={'Question: ' + itemFaq.question}
        onClose={onSetServiceRequestFormPreviousStep}
        onExit={() => {
          onExitServiceRequestForm();
          if (onExit) onExit();
        }}
        component={(
          <Row mdCenter>
            <Col
              xs="12"
              md="6"
            >

          <div>
              <div><b>Answer:</b></div> 
              <div className="service-request-form-question__body">
               {/* {itemFaq.answer} */}
               {<div dangerouslySetInnerHTML={{__html: itemFaq.answer}} />}

              </div>
              {/* </div> */}
              <div style={{paddingBottom:"3rem"}}>
              <div  style={{padding: 3, marginTop: 10}}><b>Attachment:</b> </div> 
              {itemFaq.Embed && itemFaq.Embed.length > 0 ? (
              <div className='service-request-form-question__photo' style={{backgroundColor:"transparent"}}>
                
                <div class="documents__item" style={{width:"300px"}}>
                  <div className='container' style={{  width:"100%" , height:"100%"}}>
                  <div class="h_iframe">
                    <div 
                    // style={{ height: '180px' }}
                    
                     dangerouslySetInnerHTML={{ __html: `${itemFaq.Embed} ` }} />
                  </div>
                </div>
                
                </div>
              </div>

            ):
             itemFaq.uploadType==="Image" && itemFaq.image ? 
              <div className="service-request-form-question__photo embed-video" style={{backgroundColor:"transparent"}}>
                <a href={itemFaq.image} target='_blank'>
                  <img src={itemFaq.image} />
                </a>
              </div>
              : 
              itemFaq.uploadType!=="Image" && itemFaq.image?
              // <div><iframe src={itemFaq.image} width="540" height="310"></iframe></div>
              <video width="250" height="210" controls>
              <source src={itemFaq.image} type="video/mp4" />
              </video>
              :
              
              <div style={{padding: 3}}>No attachment found.</div> 
              }
              </div>
              </div>
                {/* <div className="service-request-form-question__body">
                {itemFaq.linkTitle}
              </div> */}


              {/* <Accordion preExpanded={[0]}>
                {faqs.map((faq, x) => (
                  <AccordionItem uuid={x} key={x}>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <>
                          <AccordionItemHeading>
                            <AccordionItemButton>
                              <div className="service-request-form-questions__question">
                                {faq.question}
                                <Icon
                                  weight="light"
                                  glyph={expanded ? 'minus' : 'plus'}
                                />
                              </div>
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <div className="service-request-form-questions__answer">
                              {faq.answer}
                            </div>
                            <button
                              className="service-request-form-questions__caption"
                              type="button"
                              onClick={() => {
                                onSetServiceRequestFormNextStep()
                                onSetServiceRequestFormData({
                                  faq_id: faq.id,
                                });
                              }}
                            >
                              {faq.caption}
                            </button>
                          </AccordionItemPanel>
                        </>
                      )}
                    </AccordionItemState>
                  </AccordionItem>
                ))}
              </Accordion> */}
            </Col>
          </Row>
        )}
        footer={(
     <div style={{position: "fixed",
          bottom: "0",left:'0',
          width: "100%",
          background: "#fff", padding:'15px', boxShadow: '0 0 0.3rem rgba(0, 0, 0, 0.3)'}}>
          <>
            Did this help you resolve the issue?
            <br />
            <br />
            <Button
              color="teal"
              size="small"
              label="Yes, Return to Dashboard"
              onClick={() => onExitServiceRequestForm()}
            />
            <Button
              color="teal"
              size="small"
              label="No, NEXT: ADD DETAILS"
              onClick={() => onSetServiceRequestFormStep(6)}
            />
          </>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const serviceRequestFormData = selectServiceRequestFormData(state);
  return {
    faqsByIssue:selectFaqByIssueType(state,'Electrical'),
    faqs: selectItemFaqsByTypeAndCategory(state, serviceRequestFormData.asset_item_id, serviceRequestFormData.issueType, serviceRequestFormData.category),
    serviceRequestFormData: selectServiceRequestFormData(state)
  };
};

const maptDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSetServiceRequestFormData: setServiceRequestFormData,
  onSetServiceRequestFormNextStep: setServiceRequestFormNextStep,
  onSetServiceRequestFormStep: setServiceRequestFormStep,
  onSetServiceRequestFormPreviousStep: setServiceRequestFormPreviousStep,
  onExitServiceRequestForm: exitServiceRequestForm,
}, dispatch);

export default connect(mapStateToProps, maptDispatchToProps)(ServiceRequestFormFaqs);
